import { Prisma } from '@prisma/client'
import { FunctionalComponent } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'
import LastVisitors from '../widget-last-visitors/LastVisitors.sync'

export const widgetName = 'statistics_bar'

export const config = z.object({
  total_topics: z.boolean(),
  total_comments: z.boolean(),
  total_users: z.boolean()
})

interface Statistics {
  reactiontotal: number
  membertotal: number
  topictotal: number
}

type QueryResult = Array<{statistic: string, total: string}>

export const getServerSideProps: GetServerSideProps<z.infer<typeof config>, Statistics> = async (context, config) => {
  const statistics = {
    reactiontotal: 0,
    membertotal: 0,
    topictotal: 0
  }

  const rows = await context.cache('community-stats', () => context.prismaClient.$queryRaw<QueryResult>(Prisma.sql`SELECT statistic, total FROM statistics`))

  for (const row of rows) {
    switch (row.statistic) {
      case 'reactions':
        if (!config.total_comments) break
        statistics.reactiontotal = parseInt(row.total)
        break
      case 'members':
        if (!config.total_users) break
        statistics.membertotal = parseInt(row.total)
        break
      case 'topics':
        if (!config.total_topics) break
        statistics.topictotal = parseInt(row.total)
        break
    }
  }

  return statistics
}

const CommunityStatisticsWidget: FunctionalComponent<Statistics> = (props: Statistics) => {
  return (
    <section class='full-width Template-brand-stats custom-stats-bar'>
      <div class='stats-bar p-v qa-stats-bar'>
        <div class='sitewidth'>
          <div class='col'>
            <ul class='list list--stats-bar qa-stats-bar'>
              <li class='list__item'>
                <strong>{props.topictotal.toLocaleString()} </strong>
                <span><Phrase p='Topic|Topics' /></span>
              </li>
              <li class='list__item'>
                <strong>{props.reactiontotal.toLocaleString()} </strong>
                <span><Phrase p='Reply|Replies' /></span>
              </li>
              <li class='list__item'>
                <strong>{props.membertotal.toLocaleString()} </strong>
                <span><Phrase p='Members' /></span>
              </li>
            </ul>

            <div id='last-visitors-widget' class='last-visitors qa-last-visitors is-hidden-M pull-right'>
              <LastVisitors />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CommunityStatisticsWidget
